<template>
  <div class="card-wrapper">
    <b-card v-for="ct in categories" :key="ct.id" class="mb-3">
      <div class="d-xs-flex justify-content-between align-items-center">
        <div class="d-lg-flex d-block flex-grow-1">
          <p class="card-text w-40 w-sm-100 mb-lg-0 mb-2 mr-2">
            {{ ct.name_en }}
          </p>
          <p class="card-text w-40 w-sm-100 mb-lg-0 mb-2 mr-2">
            {{ ct.name_ru }}
          </p>
        </div>

        <div class="actions d-flex justify-content-end mt-xs-0 mt-4">
          <i @click="showInfoModal(ct.id)" class="glyph-icon simple-icon-pencil datalist-icon mr-2"></i>

          <i @click="handleDelete(ct.id)" class="glyph-icon simple-icon-trash datalist-icon"></i>
        </div>
      </div>
    </b-card>

    <!-- Modals -->
    <b-modal id="editCategoryModal" ref="editCategoryModal" size="lg" :title="'Edit Category'">
      <b-row v-if="!ctLoading">
        <b-colxx xxs="12">
          <b-card class="mb-4">
            <b-form @submit.prevent="onSubmit" class="av-tooltip">
              <b-form-group :label="$t('pages.categories.categoryImage') + ' EN'">
                <b-form-file
                  v-model="editForm.image_en"
                  accept="image/*"
                  @change="imageUploaded = !imageUploaded"
                ></b-form-file>
              </b-form-group>
              <div class="my-2 mb-4">
                <img
                  v-if="!imageUploaded && imageEnUrl !== null"
                  :src="`${apiUrl}/${imageEnUrl}`"
                  class="object-cover"
                  draggable="false"
                  width="100"
                  height="100"
                  alt=""
                />
              </div>
              <b-form-group :label="$t('pages.categories.categoryImage') + ' RU'">
                <b-form-file
                  v-model="editForm.image_ru"
                  accept="image/*"
                  @change="imageUploaded = !imageUploaded"
                ></b-form-file>
              </b-form-group>
              <img
                v-if="!imageUploaded && imageRuUrl !== null"
                :src="`${apiUrl}/${imageRuUrl}`"
                class="object-cover"
                draggable="false"
                width="100"
                height="100"
                alt=""
              />
              <b-form-group :label="$t('pages.categories.categoryImage')">
                <b-form-file
                  v-model="editForm.categoryImage"
                  accept="image/*"
                  @change="imageUploaded = !imageUploaded"
                ></b-form-file>
              </b-form-group>

              <div class="my-2 mb-4">
                <img
                  v-if="!imageUploaded && imageUrl !== null"
                  :src="`${apiUrl}${imageUrl}`"
                  class="object-cover"
                  draggable="false"
                  width="100"
                  height="100"
                  alt=""
                />
              </div>

              <b-form-group :label="$t('pages.categories.categoryIcon')">
                <b-form-file
                  v-model="editForm.categoryIcon"
                  accept="image/*"
                  @change="iconUploaded = !iconUploaded"
                ></b-form-file>
              </b-form-group>

              <div class="my-2 mb-4">
                <img
                  v-if="!iconUploaded && iconUrl !== null"
                  :src="`${apiUrl}${iconUrl}`"
                  class="object-cover"
                  draggable="false"
                  width="100"
                  height="100"
                  alt=""
                />
              </div>

              <b-form-group :label="$t('pages.categories.categoryNameEn')">
                <b-form-input type="text" v-model="$v.editForm.nameEn.$model" :state="!$v.editForm.nameEn.$error" />
                <b-form-invalid-feedback v-if="!$v.editForm.nameEn.required">
                  {{ $t('formErrors.enterName') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="$t('pages.categories.categoryNameRu')">
                <b-form-input type="text" v-model="$v.editForm.nameRu.$model" :state="!$v.editForm.nameRu.$error" />
                <b-form-invalid-feedback v-if="!$v.editForm.nameRu.required">
                  {{ $t('formErrors.enterName') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="$t('pages.categories.chooseParent')">
                <v-select
                  v-model="editForm.parent_id"
                  :options="parents"
                  :reduce="(parent) => parent.id"
                  label="name"
                />
              </b-form-group>

              <b-form-group :label="$t('anyform.chooseSection')">
                <v-select
                  v-model="editForm.section_id"
                  :options="sections"
                  :reduce="(section) => section.id"
                  label="name"
                />
              </b-form-group>

              <b-button type="submit" variant="primary" class="mt-2">
                {{ $t('buttons.save') }}
              </b-button>
            </b-form>
          </b-card>
        </b-colxx>
      </b-row>
      <div v-else class="d-flex justify-content-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>

      <template slot="modal-footer">
        <b-button variant="secondary" @click="hideModal('editCategoryModal')">
          {{ $t('buttons.cancel') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { handleArrayDataInternalization } from '@/utils'
import { apiUrl } from '@/constants/config'

const { required } = require('vuelidate/lib/validators')
export default {
  props: {
    categories: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      apiUrl,
      ctLoading: false,
      imageUrl: null,
      imageUploaded: false,
      iconUrl: null,
      iconUploaded: false,
      imageEnUrl: null,
      imageRuUrl: null,
      editForm: {
        categoryImage: null,
        categoryIcon: null,
        nameEn: '',
        nameRu: '',
        parent_id: '',
        section_id: '',
        image_en: null,
        image_ru: null
      },
      currentCategory: null
    }
  },
  validations: {
    editForm: {
      nameEn: { required },
      nameRu: { required }
    }
  },
  computed: {
    parents() {
      const requirements = this.$store.getters['categories/requirements']
      return handleArrayDataInternalization(requirements.parents, ['name'], this.$i18n.locale)
    },
    sections() {
      const requirements = this.$store.getters['categories/requirements']
      return handleArrayDataInternalization(requirements.sections, ['name'], this.$i18n.locale)
    }
  },
  mounted() {
    this.$root.$on('bv::modal::show', (_bvEvent, modalId) => {
      if (modalId === 'editCategoryModal') {
        this.clearForm()
      }
    })
  },
  methods: {
    addNotification(type, title, message) {
      this.$notify(type, title, message, { duration: 3000, permanent: false })
    },
    handleDelete(id) {
      this.$confirm({
        message: this.$t('confirm-dialog.question'),
        button: {
          no: this.$t('confirm-dialog.no'),
          yes: this.$t('confirm-dialog.yes')
        },
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch('categories/deleteCategory', {
              id,
              vm: this
            })
          }
        }
      })
    },
    showInfoModal(id) {
      this.$bvModal.show('editCategoryModal')
      this.$store.dispatch('categories/fetchCategory', { id, vm: this })
      this.currentCategory = id
    },
    onSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const payload = {
          name_en: this.editForm.nameEn,
          name_ru: this.editForm.nameRu,
          image: this.editForm.categoryImage || '',
          icon: this.editForm.categoryIcon || '',
          parent_id: this.editForm.parent_id || '',
          section_id: this.editForm.section_id || '',
          image_en: this.editForm.image_en || '',
          image_ru: this.editForm.image_ru || ''
        }

        this.$store.dispatch('categories/updateCategory', {
          payload,
          id: this.currentCategory,
          vm: this
        })
      }
    },
    clearForm() {
      this.editForm.nameEn = ''
      this.editForm.nameRu = ''
      this.editForm.categoryImage = null
      this.editForm.categoryIcon = null
      this.editForm.parent_id = ''
      this.editForm.section_id = ''
      this.editForm.image_en = null
      this.editForm.image_ru = null

      this.imageUrl = null
      this.imageUploaded = false
      this.iconUrl = null
      this.iconUploaded = false

      this.currentCategory = null
    },
    hideModal(refname) {
      this.$refs[refname].hide()
    }
  }
}
</script>
